import { createSelector } from 'reselect'

const getPurchaseOrder = ({ purchaseOrders }) => purchaseOrders.purchaseOrder

const purchaseOrdersSelectors = {
  getPurchaseOrder: createSelector([getPurchaseOrder], (purchaseOrder) => purchaseOrder),
}

export default purchaseOrdersSelectors
